import type { IReportsApiPort } from '@reports/application/ports';
import type { ReportFilterConfig } from '@reports/domain/value-objects';
import type { FilterOptionsViewDto } from '@reports/application/dtos';
import { mapFilterOptionsToViewDto } from '@reports/application/mappers';

/**
 * Use case for fetching filter catalog data
 *
 * Orchestrates fetching filter options from the API port and transforms
 * the result to a View Dto for presentation layer consumption.
 *
 * @param apiPort - Reports API port for data fetching
 * @returns Object with execute function
 *
 * @example
 * const useCase = fetchFilterCatalogUseCase(apiPort);
 * const viewDto = await useCase.execute(filterConfigs);
 */
export const fetchFilterCatalogUseCase = (apiPort: IReportsApiPort) => {
  const execute = async (filterConfigs: ReadonlyArray<ReportFilterConfig>): Promise<FilterOptionsViewDto> => {
    const filterOptions = await apiPort.fetchFilterCatalog(filterConfigs);

    // Convert ReportFilterOptions[] to FilterOptionsViewDto
    const filtersViewDto = mapFilterOptionsToViewDto(filterOptions);

    return filtersViewDto;
  };

  return { execute };
};
